import { render, staticRenderFns } from "./AmazonLockerIcon.vue?vue&type=template&id=094c8acb"
import script from "./AmazonLockerIcon.vue?vue&type=script&lang=js"
export * from "./AmazonLockerIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../tracking/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports